import { _, helpers, React, ts, ui, useSelector } from '_core';

import { Params } from './types';
import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';
import { prepareAnnuStatsData } from '../basket-compare-annualized-statistics/helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  portfolios: string;
  fullScreen: boolean;
  params: Params;
  context: ts.types.basket.BasketAnalysisContext;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, portfolios, context, params, title }: ChartProps) => {
  const baskets = useSelector((state) => state.resources.baskets);

  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) {
        const filteredData = response.data.filter((el) =>
          params.histories.includes(el.history as ts.enums.HISTORY_ENUM_EXTENDED)
        );
        setData(filteredData);
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };
  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    return prepareAnnuStatsData(nestedBarChartFormat(data), params, context, baskets);
  }, [data, params, context, baskets]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat="#.##%"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
